module.exports = __webpack_public_path__ + "static/media/wavm8s-021-risik.14ac2d8.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/wav/wavm8s-021-risik.mp3
// module id = bVTP
// module chunks = 0